import * as XLSX from 'xlsx'
import {Dictionary, Helper, Schema} from 'simpli-web-sdk'
import {snakeCase} from 'lodash'
import {FileHelper} from '@/helpers/FileHelper'
import {DataBlueprint, NormalizedItem} from 'simpli-web-sdk/lib/interfaces'

export abstract class XlsxHelper {
  static xlsArrayBufferToObject(arrBuffer: ArrayBuffer): Dictionary<any[]> {
    let binary = ''
    const bytes = new Uint8Array(arrBuffer)
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i])
    }

    const workbook = XLSX.read(binary, {
      type: 'binary',
      cellDates: true,
      cellStyles: true,
    })

    const headers: any = {}
    const sheetsData: Dictionary<any[]> = {}

    workbook.SheetNames.forEach(sheetName => {
      const data: any[] = []
      const worksheet = workbook.Sheets[sheetName]
      for (const z in worksheet) {
        if (z[0] === '!') continue
        //parse out the column, row, and value
        let tt = 0
        for (let i = 0; i < z.length; i++) {
          if (!isNaN(Number(z[i]))) {
            tt = i
            break
          }
        }
        const col = z.substring(0, tt).toUpperCase()
        const row = parseInt(z.substring(tt))
        const value = worksheet[z].v

        //store header names
        if (row == 1 && value) {
          headers[col] = value
          continue
        }

        if (!data[row]) data[row] = {}
        data[row][headers[col]] = value
      }
      //drop those first two rows which are empty
      data.shift()
      data.shift()
      sheetsData[sheetName] = data
    })

    return sheetsData
  }

  static downloadFromSchema<M>(
    list: M[],
    schema: Schema,
    fileName?: string,
    isSnakeCase: boolean = true
  ) {
    const tableData = list.map(res =>
      schema.allFields.map(f => {
        return schema.build(res, f).getData()
      })
    )

    const fileNameFormated = isSnakeCase
      ? snakeCase(fileName ?? schema.name)
      : fileName ?? schema.name

    // builds and downloads the Xlsx
    this.download(
      {
        [schema.name]: [schema.allHeaders, ...tableData],
      },
      fileNameFormated
    )
  }

  static download(
    pages: Dictionary<any[][]>,
    filename: string,
    wsBuilder?: (ws: XLSX.WorkSheet, index: number) => void
  ) {
    const wb = XLSX.utils.book_new()

    Object.keys(pages).forEach((pageName, i) => {
      const ws = XLSX.utils.aoa_to_sheet(pages[pageName])
      wsBuilder && wsBuilder(ws, i)
      XLSX.utils.book_append_sheet(wb, ws, pageName)
    })

    XLSX.writeFile(wb, `${filename}.xlsx`, {cellStyles: true, bookSST: true})
  }

  static async xlsxToNormalizeData<T extends DataBlueprint>(
    file: File | null,
    blueprint: T,
    forceValuesToString?: boolean
  ) {
    /*
      O forceValuesToString é um parametro opcional
      e serve para o caso de precisar ler o 0 e/ou
      diferenciar se a celula não foi preenchida
    */
    if (file == null) return null
    const arrayBufferFile = await FileHelper.fileToArrBuffer(file)
    if (arrayBufferFile) {
      const data = this.xlsArrayBufferToObject(arrayBufferFile)
      const castedData = Object.values(data)[0]
      if (forceValuesToString) {
        castedData.forEach((rowObject, indexRow) => {
          Object.keys(rowObject).forEach(attribute => {
            if (castedData[indexRow][attribute] !== undefined) {
              castedData[indexRow][attribute] = castedData[indexRow][attribute]
                .toString()
                .trim()
            }
          })
        })
      }
      return Helper.normalizeData(castedData, blueprint)
    }
    return null
  }
}
